// source: api/soter-task/common/v1/video_type_enum.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.taskVideoType.TaskVideoType', null, global);
/**
 * @enum {number}
 */
proto.taskVideoType.TaskVideoType = {
  NONE: 0,
  TASK_ASSESSMENT: 1,
  COACHING: 2,
  OTHER: 3
};

goog.object.extend(exports, proto.taskVideoType);
